
import angular from 'angular';
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import { AncillariesUtilsService } from 'src/app/shared/ib-web-ancillaries-utils';

const controllerInfo = {
    module: 'ib-insurance-module',
    inject: ['$uibModalInstance', 'object', 'DatalayerUtilsService', '$rootScope', 'localStorageService', 'AncillariesConstants', '$timeout', 'CommonsConstants', 'DatalayerConstants', 'DatalayerUtils', 'CommonsUtilService', 'AncillariesUtilsService', '$sce'],
    required: []
};
export class InsuranceAncModalController implements ng.IController {
    public model;
    public isModalLoading;
    public insuranceForm;
    public status;
    public isRemoveFromCart;
    constructor (
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private object: any,
        private DatalayerUtilsService: DatalayerUtilsService,
        private $rootScope: CommonsRootScope,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private AncillariesConstants: AncillariesConstant,
        private $timeout: ng.ITimeoutService,
        private CommonsConstants: CommonsConstantsType,
        private DatalayerConstants: DatalayerConstantsType,
        private DatalayerUtils: DatalayerUtils,
        private CommonsUtilService: CommonsUtilService,
        private AncillariesUtilsService: AncillariesUtilsService,
        private $sce: any) {
        this.model = object;
    }

    /**
     * Initialize modal controller
     */
    $onInit (): void {
        const status = this.localStorageService.get('selectInsurance');
        this.isRemoveFromCart= this.localStorageService.get('insuranceSelected');
        this.isModalLoading = false;
        if (status) {
            this.model.selectedInsurance = this.model.insuranceInfo;
            angular.forEach(this.model.ancillariesInsurance, (insurance) => {
                if (this.model.insurance && (insurance.id === this.model.insurance.id || insurance.id === this.model.insuranceInfo.id)) {
                    this.model.selectedInsurance = insurance;
                    this.selectInsurance(true);
                } else if (insurance.id === this.model.insuranceInfo.id) {
                    this.model.selectedInsurance = insurance;
                    this.selectInsurance(true);
                } else if (insurance.id === this.model.insuranceInfo.id) {
                    this.model.selectedInsurance = insurance;
                    this.selectInsurance(true);
                }
            });
        } else {
            this.model.selectedInsurance = null;
        }
        this.$uibModalInstance.result.then(this.DatalayerUtilsService.removeDatalayerModalAttrs, this.DatalayerUtilsService.removeDatalayerModalAttrs);
        this.$timeout(() => {
            this.CommonsUtilService.setTitlePage('MMB_INSURANCE_MODAL_TITLE');
            /* INIT DELETE GA4 MIGRATION */
            this.DatalayerUtilsService.updateDatalayerWithQuadrigam(this.CommonsConstants.QUADRIGAM.MODAL_SELECT_INS, null, this.localStorageService.get('userLogged'));
            this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
            /* FINISH DELETE GA4 MIGRATION*/
            this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(this.CommonsConstants.QUADRIGAM.MODAL_SELECT_INS, null, this.localStorageService.get('userLogged'));
            this.DatalayerUtilsService.setProcessAndStep(this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, this.DatalayerConstants.DATALAYER_ANCILLARIES_STEPS.MODINS, this.CommonsConstants.QUADRIGAM.MODAL_SELECT_INS);
            this.DatalayerUtilsService.updateDatalayerViewEvent();
            if (this.AncillariesUtilsService.isBookingFlow()) {     //BKI
                this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), null, this.CommonsConstants.QUADRIGAM.MODAL_SELECT_INS);
            } else if (this.AncillariesUtilsService.isCheckinFlow()) {  //CKI
                this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), null, this.CommonsConstants.QUADRIGAM.MODAL_SELECT_INS);
            } else if (this.AncillariesUtilsService.isMMBFlow()) {  //MMB
                this.DatalayerUtilsService.setProcessAndStep(this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, this.DatalayerConstants.DATALAYER_ANCILLARIES_STEPS.MODINS, this.CommonsConstants.QUADRIGAM.MODAL_SELECT_INS);
            } else {    //OTHER FLOWs
                this.DatalayerUtilsService.setProcessAndStep(this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, this.DatalayerConstants.DATALAYER_ANCILLARIES_STEPS.MODINS, this.CommonsConstants.QUADRIGAM.MODAL_SELECT_INS);
            }
            this.$rootScope.$broadcast('updateDatalayer');
            this.$rootScope.$broadcast('updateDigitalData');
            this.$rootScope.$broadcast('sendUpdateToMonetate');
        });
    }

    /**
     * Delete insurance of model
     * @param {Object} evt
     */
    deleteInsurance = (evt): void => {
        this.model.selectedInsurance = null;
        this.$rootScope.$broadcast('updateInsuranceSelectedStatus');
    };

    /**
     * Show or hide loading view
     * @param {*} evt
     * @param {*} isLoading
     */
    isLoading = (evt: any, isLoading: any): void => {
        this.isModalLoading = isLoading;
    };
    /**
     * Refresh insurance info
     * @param {Object} evt
     * @param {Object} modelInfo  Ancillaries info
     */
    refreshInsuranceInfo = (evt: any, modelInfo: any): void => {
        this.model = modelInfo;
        this.isModalLoading = false;
    };

    /**
     * Emits event for call service of ancillaries for get
     * conditions of insurance with diferrent country
     * @param {Object} country Country selected in combo for get new price  of insurance
     */
    changeInsuranceCountry = (country: any): void => {
        if (this.model.insurance && this.model.insurance.policyHolder) {
            this.model.insurance.policyHolder = null;
            this.model.insurance.passengerDocument = '';
            this.localStorageService.remove('birthDate');
        }
        this.localStorageService.set('saveSelectedInsurance', true);
        this.$rootScope.$broadcast('changeInsuranceCountry', country);
    };

    setSelectedInsurance = (evt, insurance): void => {
        this.model.selectedInsurance = insurance;
    };

    updateDataLayerAndDigitalData = (): void => {
        const flow = this.localStorageService.get('flowApp');
        let quadrigam = '';
        switch (flow) {
                case this.AncillariesConstants.APPLICATION_FLOW.BBOOKING:
                case this.AncillariesConstants.APPLICATION_FLOW.BOOKING:
                    quadrigam = this.CommonsConstants.STEP_FLOW.ANCILLARIES.toUpperCase();
                    break;
                case this.AncillariesConstants.APPLICATION_FLOW.CHECKIN:
                    quadrigam = this.AncillariesConstants.QUADRIGAM.ANCILLARIES;
                    break;
        }
        /* INIT DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, quadrigam);
        this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
        /* FINISH DELETE GA4 MIGRATION*/
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.updateDatalayerViewEvent();
    };

    /**
     * Check if form is valid, emit event to parent and close modal window
     * @param {Object} insuranceForm Info of the insurance form
     */
    completeForm = (): void => {
        const flow = this.localStorageService.get('flowApp');
        if (this.status) {
            this.insuranceForm.$submitted = true;
            if (this.model.insurance) this.model.selectedInsurance = this.model.insurance;
            if (this.insuranceForm.$valid) {
                this.DatalayerUtils.setInsuranceEcommerce(this.model.selectedInsurance, 'add_to_cart');
                if (this.model.selectedInsurance.passengerDocument && this.model.selectedInsurance.passengerDocument.length > 0 && this.model.selectedInsurance.policyHolder) {
                    this.model.selectedInsurance.policyHolder.document = this.model.selectedInsurance.passengerDocument;
                } else if (this.model.insuranceInfo.passengerDocument && this.model.insuranceInfo.passengerDocument.length > 0 && this.model.insuranceInfo.policyHolder) {
                    this.model.selectedInsurance.policyHolder = this.model.insuranceInfo.policyHolder;
                    this.model.selectedInsurance.policyHolder.document = this.model.insuranceInfo.passengerDocument;
                    this.model.selectedInsurance.policyHolder.birthDate = (this.model.insuranceInfo.birthDateYear.year).toString() + '-' + this.model.insuranceInfo.birthDateMonth + '-' + this.model.insuranceInfo.birthDateDay;
                    this.localStorageService.set('birthDate', this.model.selectedInsurance.policyHolder.birthDate);
                }
                this.selectInsurance(true);
                this.$rootScope.$broadcast('selectInsuranceControl', this.model.selectedInsurance, true);
                this.localStorageService.set('insuranceSelected', this.model.selectedInsurance);
                this.localStorageService.set('selectInsurance', this.status);
                this.$rootScope.$broadcast('updateInsuranceSelectedStatus');
                this.$uibModalInstance.close('cancel');
                this.DatalayerUtilsService.updateDatalayerActionForAncillaries(
                    this.AncillariesConstants.DATALAYER_INFO.SEGUROS, this.AncillariesConstants.DATALAYER_INFO.CLICK, 'ok:' + this.model.selectedInsurance.name);
                this.DatalayerUtilsService.setAncillariesDatalayer();
            }
        } else {
            if(this.isRemoveFromCart) this.DatalayerUtils.setInsuranceEcommerce(this.model.ancillariesInsurance[0], 'remove_from_cart');
            this.localStorageService.set('saveSelectedInsurance', false);
            this.$rootScope.$broadcast('selectInsurance', this.model.selectedInsurance /*this.model.insurance*/);
            this.localStorageService.set('selectInsurance', this.status);
            this.$rootScope.$broadcast('updateInsuranceSelectedStatus');
            this.localStorageService.set('insuranceSelected', null);
            this.$uibModalInstance.close('cancel');
            this.DatalayerUtilsService.setAncillariesDatalayer();
        }
        if(flow !== this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            this.updateDataLayerAndDigitalData();
        }
    };

    /**
    * Close modal and send event for discard changes on insurance
    */
    close = (): void => {
        const flow = this.localStorageService.get('flowApp');
        this.localStorageService.set('saveSelectedInsurance', false);
        this.localStorageService.set('insuranceSelected', null);
        this.DatalayerUtilsService.setAncillariesDatalayer();
        this.$rootScope.$broadcast('cancelChangesInsurance');
        this.$uibModalInstance.dismiss('cancel');
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
        if(flow !== this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            this.updateDataLayerAndDigitalData();
        }
    };

    /**
     * Emits event with select insurance and save in localStorage state of if is selected or not
     * @param {BOOL} status
     */
    selectInsurance = (status: any): void => {
        const isSelected = this.localStorageService.get('selectInsurance');
        if (this.model.selectedInsurance === null) this.model.selectedInsurance = this.model.ancillariesInsurance[0];
        if (!this.insuranceForm?.$submitted && (this.model.selectedInsurance && (!isSelected && status))) {
            this.DatalayerUtils.setInsuranceEcommerce(this.model.selectedInsurance, 'select_item');
        }
        if (!status && this.insuranceForm) {
            this.insuranceForm.$submitted = false;
        }
        if (status) {
            this.DatalayerUtilsService.updateDatalayerActionForAncillaries(
                this.AncillariesConstants.DATALAYER_INFO.SEGUROS, this.AncillariesConstants.DATALAYER_INFO.CLICK, 'ko:' + this.model.selectedInsurance.name);
        } else {
            this.DatalayerUtilsService.updateDatalayerActionForAncillaries(
                this.AncillariesConstants.DATALAYER_INFO.SEGUROS, this.AncillariesConstants.DATALAYER_INFO.CLICK, 'ko:' + this.model.ancillariesInsurance[0].name);
        }
        this.localStorageService.set('selectInsurance', status);
        this.status = status;
        this.$rootScope.$broadcast('updateInsurance');
    };


    conditionsControl = (consent): any => {
        let result = false;
        if (consent) {
            if (consent.length > 5) {
                result = true;
            }
        }
        return result;
    };

    birthDateSelected = (evt: any, birthDate: any): void => {
        if (this.model.insurance && birthDate.year && this.model.insurance.policyHolder) {
            this.model.insurance.policyHolder.birthDate = (birthDate.year).toString() + '-' + birthDate.month + '-' + birthDate.day;
            this.localStorageService.set('birthDate', this.model.insurance.policyHolder.birthDate);
        }
    };

    changeInsurancePolicyHolder = (passenger: any, insurance: any): void => {
        const birthDate = this.localStorageService.get('birthDate');
        if (!passenger.birthDate || birthDate !== passenger.birthDate) {
            passenger.document = '';
            insurance.passengerDocument = '';
            insurance.birthDateDay = '';
            insurance.birthDateMonth = '';
            if (insurance.birthDateYear !== null) {
                insurance.birthDateYear.year = '';
            }
            this.$rootScope.$broadcast('controlBirthDate');
        }
    };

    hasRequieredFields = (requiredFields): any => {
        let hasRequieredFieldControl = false;
        if (requiredFields && (requiredFields.requiredField === this.AncillariesConstants.PASSENGERFIELDS.DOCUMENT_ID || requiredFields.requiredField === this.AncillariesConstants.PASSENGERFIELDS.BIRTH_DATE || requiredFields.requiredField === this.AncillariesConstants.PASSENGERFIELDS.POLICY_HOLDER)) {
            hasRequieredFieldControl = true;
        }
        return hasRequieredFieldControl;
    };
    controlClicking = (): void => {
        this.DatalayerUtilsService.updateDatalayerActionForAncillaries(this.AncillariesConstants.DATALAYER_INFO.SEGUROS,
            this.AncillariesConstants.DATALAYER_INFO.CLICK, this.AncillariesConstants.DATALAYER_INFO.INSURANCE_CONDITIONS);
    };
    closeInfoModal = (): void => {
        this.$uibModalInstance.dismiss('cancel');
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
    };

}


try {
    InsuranceAncModalController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(InsuranceAncModalController.name, InsuranceAncModalController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    InsuranceAncModalController.$inject = controllerInfo.inject;
    mod.controller(InsuranceAncModalController.name, InsuranceAncModalController);
}